import { animated } from '#app/components/Primitives/Animated.js';
import { springAnimation } from '#app/utilities/animation.js';
import { ChevronUpIcon } from '@contra/icons/icons';
import { type HTMLAttributes } from 'react';
import { styled } from 'styled-components';

type TextFieldChevronProps = HTMLAttributes<HTMLButtonElement> & {
  readonly isDisabled?: boolean;
  readonly isOpen: boolean;
};

const ChevronContainer = styled(animated.div)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextFieldChevron = ({
  isDisabled = false,
  isOpen,
}: TextFieldChevronProps) => {
  return (
    <ChevronContainer
      animate={{
        rotate: isOpen ? 0 : 180,
      }}
      aria-label={`chevron-${isOpen ? 'up' : 'down'}`}
      initial={false}
      transition={springAnimation.fast}
    >
      <ChevronUpIcon
        focusable={false}
        size={24}
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.2 : 1,
        }}
      />
    </ChevronContainer>
  );
};

TextFieldChevron.displayName = 'TextField.Chevron';
